import styled from "styled-components";

export const BigGrade = styled("h5")`
  margin: 3px auto 14px auto;
  font-size: 60px;
  font-weight: 500;
  color: #001e6c;
`;
